/* tslint:disable:typedef-whitespace align no-trailing-whitespace */

import { Action, ActionType    } from '@/models/action';
import { ModalService          } from '@/services/modal.service';

/**
 *
 * @class ProjectOpenAction
 *
 * @brief open an existing project
 *
 * - - - - - - - - - - - - - - - - - - -
 * @author    Michael Garvin (mike.garvin@ironroad.ca)
 * @date      March 2020
 *
 */
export class ProjectOpenAction extends Action {

  private modals: ModalService        = null;

  constructor(options: any = null) {

    super({
      key:   'project.open',
      type:  ActionType.Project_Open,
      label: 'Open',
      icon:  '<i class="far fa-folder-open"></i>',
      tip:   'Open an existing project'
    });

    this.modals   = this.injector().get(ModalService);
  }

  /* is this action enabled? */
  public enabled(): boolean {

    return true;
  }

  /** implement the action */
  public execute(): boolean {

    if (!this.enabled()) {
      return false;
    }

    this.modals.open('open-project-modal');

    return true;
  }
}
